export const changeDay = (date: string, days: number) => {
    const newDate = new Date(date);
    const dayOfTheMonth = newDate.getUTCDate();

    newDate.setUTCDate(dayOfTheMonth + days);

    return newDate.toISOString().split('T')[0];
};

export const getDateRange = (date: string) => {
    const dates = [];

    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const tomorrow = changeDay(today, 1);

    const isToday = date === today;
    const isTomorrow = date === tomorrow;

    const dayBefore = changeDay(date, -1);
    const twoDaysBefore = changeDay(date, -2);

    dates.push({ date: twoDaysBefore, isDisabled: isToday || isTomorrow }); // don't fetch two days before if date is today or tomorrow
    dates.push({ date: dayBefore, isDisabled: isToday }); // don't fetch any previous dates if date is today

    dates.push({ date: changeDay(date, 0), isActive: true, isDisabled: false });

    const numFollowingDays = 5;

    for (let i = 1; i <= numFollowingDays; i += 1) {
        dates.push({ date: changeDay(date, i), isDisabled: false });
    }

    return dates;
};
